






import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {AUTH_GET_CLIENT, AUTH_GET_COUNTRY, AUTH_GET_VEHICLETYPE} from '@/store/modules/authentication/types';
import {Client} from '@/store/modules/authentication/interfaces';

import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';
import {ClientEnum} from '@/enums/client.enum';
import {TupleDictionary} from '@/utils/tupleDictionary';

import ReportPowerBiContainer from '../../components/report-powerbi-container/report-powerbi-container.vue';
import {CountryEnum, CountryType} from '@/enums/country.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';
import {VehicleTypeEnum} from '@/enums/vehicle-type.enum';

@Component({
  name: 'PbiAnnualSalesPerformancePage',
  components: { ReportPowerBiContainer }
})

export default class PbiAnnualSalesPerformancePage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  @Getter(AUTH_GET_VEHICLETYPE)
  public idVehicleType: number;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();

  public dictReports = new TupleDictionary<[ClientEnum, VehicleTypeEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {    
    this.dictReports.set([ClientEnum.Mitsubishi, VehicleTypeEnum.Car, CountryEnum.Brasil], { brand: 'Mitsubishi', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'ceb38766-8d6c-4115-9c3b-67a17dc9cbfe' });

    this.crrReport = this.dictReports.get([this.client.id, this.idVehicleType, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Annual Sales Performance (ASP)`);
  }
}
